import { render, staticRenderFns } from "./departBalance.vue?vue&type=template&id=6f86c044&scoped=true&"
import script from "./departBalance.vue?vue&type=script&lang=js&"
export * from "./departBalance.vue?vue&type=script&lang=js&"
import style0 from "./departBalance.vue?vue&type=style&index=0&id=6f86c044&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f86c044",
  null
  
)

export default component.exports